const startPage: Record<string, Record<string, string> | string> = {
    logoAlt: 'Дирекция НТП',
};

export default startPage;
